// Backend API configuration
export const API_BASE_URL =
  typeof window !== 'undefined' && window.location.origin.includes('analystbro')
    ? window.location.origin
    : import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
export const API_CHAT_STREAM_URL = `${API_BASE_URL}/api/chat`;

// Agent BRAND name shown in the UI. Decoupled from the engine: today the engine
// is Hermes (internal — components, /api/agent/hermes/session, HERMES_* env, the
// hermes-proxy worker all stay "hermes"), but users see this brand. Swap the
// engine later without touching the brand. Rebrand = change this one line.
export const AGENT_NAME = "AnalystBro";

// <AGENT_NAME> baseUrl is brokered per-user via GET /api/agent/hermes/session/
// (see src/hooks/useHermesSession.js) — no static config needed.

// Google OAuth configuration
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '656537335876-4nqm9bns0p9nik6ik2qnf3p9e8464mgr.apps.googleusercontent.com';

// Contact email
export const SALES_EMAIL = import.meta.env.VITE_SALES_EMAIL || 'mainul@analystbro.net';

// ── AnalystBro Desktop downloads ────────────────────────────────────────────
//
// The desktop app is what runs the research agent locally: it drives the ACP
// agent, reaches the corpus through a local proxy, and renders TradingView
// charts on the user's own machine.
//
// Files are served from the same origin under /downloads/ rather than bundled
// into the frontend — each installer is 4-6 MB and has nothing to do with the
// web build. `deploy.sh` wipes /var/www/html on every deploy, so that
// directory is preserved explicitly there.
//
// VITE_DOWNLOAD_BASE overrides the location (a CDN, an S3 bucket) without a
// code change.
export const DOWNLOAD_BASE = import.meta.env.VITE_DOWNLOAD_BASE || '/downloads';
export const DESKTOP_VERSION = import.meta.env.VITE_DESKTOP_VERSION || '0.1.0';

export const DESKTOP_DOWNLOADS = [
  {
    id: 'windows',
    label: 'Windows',
    detail: '10 or 11, 64-bit',
    file: `AnalystBro_${DESKTOP_VERSION}_x64-setup.exe`,
    // Installs per-user, so it needs no administrator rights — which matters
    // on locked-down corporate machines.
    note: 'No admin rights needed',
  },
  {
    id: 'mac-arm',
    label: 'macOS',
    detail: 'Apple Silicon (M1 and later)',
    file: `AnalystBro_${DESKTOP_VERSION}_aarch64.dmg`,
  },
  {
    id: 'mac-intel',
    label: 'macOS',
    detail: 'Intel',
    file: `AnalystBro_${DESKTOP_VERSION}_x64.dmg`,
  },
];
